import { useMemo, createContext, useCallback, useContext, useState } from 'react';

type LocaleSelectionContextModel = {
  toggleLocaleSelectionVisibility: () => void;
  localeSelectionVisible: boolean;
};

type LocaleSelectionContextProviderProps = {
  children?: React.ReactNode;
};

const LocaleSelectionContext = createContext<LocaleSelectionContextModel | null>(null);

export const LocaleSelectionContextProvider = ({ children }: LocaleSelectionContextProviderProps) => {
  const [visible, setVisible] = useState<boolean>(false);

  const toggle = useCallback(() => setVisible(!visible), [visible]);
  const providerProps = useMemo(
    () => ({ toggleLocaleSelectionVisibility: toggle, localeSelectionVisible: visible }),
    [toggle, visible]
  );
  return <LocaleSelectionContext.Provider value={providerProps}>{children}</LocaleSelectionContext.Provider>;
};

export const useLocaleSelectionContext = () => {
  const context = useContext(LocaleSelectionContext);
  if (context === null) {
    throw new Error('Make sure to wrap your components with <LocaleSelectionContextProvider/>');
  }
  return context;
};
